import React from 'react';
import classNames from 'classnames';
import PlaceholderJugador from 'containers/Mundial2026/assets/placeholders/Jugador.png';

export default function PlaceholderAvatar({ className = '', photo, alt = '' }) {
  const rootClass = classNames('wca-lineaciones__avatar-ph', className).trim();

  return (
    <span className={rootClass}>
      <img
        className="wca-lineaciones__avatar-ph-img"
        src={photo || PlaceholderJugador}
        alt={alt}
        onError={e => {
          e.currentTarget.onerror = null;
          e.currentTarget.src = PlaceholderJugador;
        }}
      />
    </span>
  );
}
